import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  destroyByUserAndDate({ userId, date }) {
    return axiosIns.delete(
      '/v2/eod_closing/business_rule_results/destroy_by_user_and_date',
      {
        params: snakecaseKeys({ userId, date }),
      },
    )
  },
}
